[
  {
    "code": "TD-BA",
    "name": "Batha"
  },
  {
    "code": "TD-BET",
    "name": "Borkou-Ennedi-Tibesti"
  },
  {
    "code": "TD-CB",
    "name": "Chari-Baguirmi"
  },
  {
    "code": "TD-GR",
    "name": "Guéra"
  },
  {
    "code": "TD-HL",
    "name": "Hadjer Lamis"
  },
  {
    "code": "TD-KA",
    "name": "Kanem"
  },
  {
    "code": "TD-LC",
    "name": "Lac"
  },
  {
    "code": "TD-LO",
    "name": "Logone-Occidental"
  },
  {
    "code": "TD-LR",
    "name": "Logone-Oriental"
  },
  {
    "code": "TD-MA",
    "name": "Mandoul"
  },
  {
    "code": "TD-ME",
    "name": "Mayo-Kébbi-Est"
  },
  {
    "code": "TD-MO",
    "name": "Mayo-Kébbi-Ouest"
  },
  {
    "code": "TD-MC",
    "name": "Moyen-Chari"
  },
  {
    "code": "TD-ND",
    "name": "Ndjamena"
  },
  {
    "code": "TD-OD",
    "name": "Ouaddaï"
  },
  {
    "code": "TD-SA",
    "name": "Salamat"
  },
  {
    "code": "TD-TA",
    "name": "Tandjilé"
  },
  {
    "code": "TD-WF",
    "name": "Wadi Fira"
  }
]